export default "__VITE_ASSET__BEwn0UTr__"